import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/greatest-weakness",
  title: "Greatest Weakness Interview Answer",
  seoTitle: "How to Answer What Is Your Greatest Weakness | HiredCoach",
  seoDescription:
    "Build a credible answer to 'What is your greatest weakness?' with examples, mistakes to avoid, and a Coach U CTA.",
  heroEyebrow: '"What\'s your greatest weakness?"',
  heroHeadline: "If your answer sounds disingenuious, you'll give off the wrong impression",
  heroSubhead:
    "Most give a polished answer that interviewers don't believe. Here's how to give one that actually lands.",
  heroPrimaryCta: "Try a real answer",
  heroPanelEyebrow: "What actually works",
  heroPanelTitle: "What actually works",
  heroPanelBullets: [
    "Pick a real weakness (not a safe fake one)",
    "Show where it caused problems - make it relatable",
    "Explain what you changed to fix it; show personal growth",
  ],
  heroPanelFooter: "If it sounds polished, it sounds fake.",
  frameworkTitle: "How to make this sound believable",
  frameworkBullets: [
    "Choose something real, but not role-breaking",
    "Describe what you do, not a personality trait",
    "Show the moment it caused friction",
    "End with proof it’s improved",
  ],
  exampleTitle: "What a good version sounds like",
  exampleBlocks: [
    'It worked at first, but started slowing projects down as things got bigger. I fixed it by setting clear ownership upfront and doing quick weekly check-ins. That’s made collaboration smoother and removed bottlenecks.',
    "I had a habit of over-explaining things, especially in meetings. It sometimes made my points less clear and took up too much time. I started prepping tighter summaries and focusing on the key takeaway first. Now my communication is a lot more direct.",
  ],
  mistakesTitle: "Why this answer usually flops",
  mistakes: [
    "People use fake unimportant weaknesses and it shows",
    "They pick something that doesn't affect your actual role",
    "They skip what actually changed or try to make themselves the hero",
    "They sound defensive instead of honest about growth",
  ],
  ctaEyebrow: "You need good feedback",
  ctaTitle: "Practice questions like this and get properly reviewed",
  ctaBullets: [
    "Pick something real",
    "Make the behavior specific",
    "Walk through the fix clearly",
    "Show self awareness and growth",
  ],
  ctaInfoCard: {
    title: "Learn from CoachU",
    path: "/public-learn",
    description: "Browse interview content, frameworks, and practice ideas before your next round.",
  },
  ctaActionTitle: "Try mock questions",
  ctaActionDescription: "Say it out loud, hear what still sounds fake, and fix it before the real interview.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "Tell Me About Yourself Interview Answer",
      path: "/tell-me-about-yourself",
      description: "Build a clear story that doesn't ramble or sound scripted.",
    },
    {
      title: "Common Interview Mistakes",
      path: "/common-interview-mistakes",
      description: "The small things that quietly kill your chances (and how to fix them).",
    },
    {
      title: "Interview Tips",
      path: "/interview-tips",
      description: "Practical ways to sound confident without faking it.",
    },
  ],
  faqs: [
    { question: "Should your weakness be real?", answer: "Yes. If it sounds too perfect, interviewers don't buy it." },
    { question: "Can you say perfectionism?", answer: "Sounds cute in the movies - causes eye rolls in real life." },
  ],
};

export default function GreatestWeaknessPage() {
  return <SeoLandingTemplate page={page} />;
}
